"use client";

import { useRef } from "react";
import { useDateSegment } from "react-aria";
import { DateFieldState, DateSegment as IDateSegment } from "react-stately";
import { cn } from "../../utils";

interface DateSegmentProps {
  segment: IDateSegment;
  state: DateFieldState;
}

// French placeholders instead of react-aria's "––", so an empty field reads as a time.
const PLACEHOLDER_BY_SEGMENT: Partial<Record<IDateSegment["type"], string>> = {
  hour: "hh",
  minute: "mm",
};

function DateSegment({ segment, state }: DateSegmentProps) {
  const ref = useRef(null);

  const {
    segmentProps: { ...segmentProps },
  } = useDateSegment(segment, state, ref);

  return (
    <div
      {...segmentProps}
      ref={ref}
      className={cn(
        "focus:bg-accent focus:text-accent-foreground focus:rounded-[2px] focus:outline-none",
        segment.type !== "literal" ? "px-[1px]" : "",
        segment.isPlaceholder ? "text-muted-foreground" : ""
      )}
    >
      {segment.isPlaceholder
        ? (PLACEHOLDER_BY_SEGMENT[segment.type] ?? segment.text)
        : segment.text}
    </div>
  );
}

export { DateSegment };
